import React from 'react';
import { Link } from 'react-router-dom';
import { errorNotificationBuilder, successNotificationBuilder } from './notification-builder';
import { NotificationTypes } from '../components/notifications';

enum SuccessMessage {
  SWITCH_TRAIL_TO_ANNUAL = 'Successfully switched from trial to annual subscription',
  SWITCH_TO_MONTHLY = 'Successfully switched to monthly subscription',
  CHANGE_PRICING_PLAN = 'Successfully changed pricing plan',
  MANAGE_SUBSCRIPTION = 'Plan changed successfully',
  UPDATE_PLAN = 'Plan changed successfully',
  SUBSCRIBE_TO_ADDONS = 'Successfully subscribed to add-ons',
  SUBSCRIBE_TO_ADDONS_V2 = 'A new invoice is being generated and will be available in 24 hours. You can view the changes in the order history tab.',
  SCHEDULED_ORDER = 'This is a scheduled change that will take place on the next bill date.',
  REWIND_PLAN = 'Plan rewind successfully',
  REWIND_PLAN_V2 = 'The subscription has been changed. A new invoice will be available in 24 hours. You can view the changes in Order history.',
}

enum HeaderMessage {
  SWITCH_TRAIL_TO_ANNUAL = 'Trial to annual subscription update succeeded',
  SWITCH_MONTHLY_TO_ANNUAL = 'Monthly to annual subscription update succeeded',
  SWITCH_TO_MONTHLY = 'Annual to monthly subscription update succeeded',
  CHANGE_PRICING_PLAN = 'Change pricing plan',
  MANAGE_SUBSCRIPTION = 'Manage subscription',
  UPDATE_PLAN = 'Change plan',
  SUBSCRIBE_TO_ADDONS = 'Subscribe to add-ons',
  SCHEDULED_ORDER = 'Order submitted successfully',
  REWIND_PLAN = 'Plan rewind to previous subscription succeeded',
  REWIND_PLAN_V2 = 'Task complete',
  SUBSCRIBE_TO_ADDONS_V2 = 'Subscribe to additional allocations',
}

const getNotificationContent = () => {
  return (
    <div>
      <p>
        The subscription has been changed. A new invoice will be available in 24 hours. You can view the changes in{' '}
        <strong>Order history</strong>
      </p>
      <Link to={`#order-history`}>View order history</Link>
    </div>
  );
};

export const orderSuccessNotification = (
  //todo: create logic for scheduled vs immediate and change enum messages
  type: keyof typeof HeaderMessage,
  transitionTime: string,
  additionalDetail?: string,
  versionFlag?: boolean
) => {
  const notification = versionFlag
    ? successNotificationBuilder().withId(`${type}-success`).isVersion(NotificationTypes.FLAG)
    : successNotificationBuilder().withId(`${type}-success`);

  return notification
    .withHeader(
      //todo: remove 'NEXT_CYCLE' when not depending on feature_flag (IPA-4533)
      transitionTime === 'NEXT_CYCLE' || transitionTime === 'SCHEDULE'
        ? HeaderMessage.SCHEDULED_ORDER
        : HeaderMessage[type as keyof typeof HeaderMessage]
    )
    .withMessage(
      transitionTime === 'NEXT_CYCLE' || transitionTime === 'SCHEDULE' || transitionTime === 'SCHEDULED'
        ? SuccessMessage.SCHEDULED_ORDER
        : type === 'REWIND_PLAN_V2'
        ? getNotificationContent()
        : `${SuccessMessage[type as keyof typeof SuccessMessage]}${additionalDetail ? additionalDetail : ''}`
    )
    .withDismissAfter(5000)
    .build();
};

export const updateTransactionAccountSuccessNotification = ({
  heading,
  message,
}: {
  heading?: string;
  message?: string;
}) => {
  const successMessage = message || 'Successfully updated billing account';

  return successNotificationBuilder()
    .isVersion(NotificationTypes.FLAG)
    .withId('update-transaction-account-success')
    .withHeader(heading || 'Update billing account succeeded')
    .withMessage(successMessage)
    .withDismissAfter(5000)
    .build();
};

export const updateTransactionAccountFailedNotification = ({
  detailList = [],
  heading,
  message = '',
}: {
  detailList?: (() => JSX.Element)[];
  heading?: string;
  message?: JSX.Element | string;
}) => {
  return errorNotificationBuilder()
    .isVersion(NotificationTypes.FLAG)
    .withId('update-transaction-account-fail')
    .withHeader(heading || 'Update billing account failed')
    .withMessage(message)
    .withDetailList(detailList)
    .withDismissAfter(5000)
    .build();
};
